<form *ngIf="stepForm"
      id="step-form"
      [formGroup]="stepForm">
    <div class="request-container-4 request-content4-scrollable aa-scrollable-y aa-scrollbar">
        <div class="request-content">
            <fieldset formGroupName="main">
                <legend>{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP4.INFORMATIONS' | translate }}</legend>
                <div class="input-row">
                    <aa-input-text2 class="full-field"
                                    name="email"
                                    label="{{ 'ITSM.PROFILE.INFORMATIONS.EMAIL' | translate }}"
                                    [notEnabled]="true"
                                    formControlName="email">
                    </aa-input-text2>
                    <aa-input-text2 class="half-field"
                                    name="firstname"
                                    label="{{ 'ITSM.PROFILE.INFORMATIONS.FIRSTNAME' | translate }}"
                                    required
                                    formControlName="firstName">
                    </aa-input-text2>
                    <aa-input-text2 class="half-field"
                                    name="lastname"
                                    label="{{ 'ITSM.PROFILE.INFORMATIONS.NAME' | translate }}"
                                    required
                                    formControlName="lastName">
                    </aa-input-text2>
                    <aa-input-text2 class="half-field"
                                    name="title"
                                    label="{{ 'ITSM.PROFILE.INFORMATIONS.TITLE' | translate }}"
                                    formControlName="title">
                    </aa-input-text2>
                    <aa-input-phone2 class="half-field"
                                     name="phoneNumber"
                                     label="{{ 'ITSM.PROFILE.INFORMATIONS.PHONENUMBER' | translate }}"
                                     formControlName="phoneNumber">
                    </aa-input-phone2>
                    <aa-input-phone2 class="half-field"
                                     name="mobile"
                                     label="{{ 'ITSM.PROFILE.INFORMATIONS.MOBILE' | translate }}"
                                     formControlName="mobile">
                    </aa-input-phone2>
                    <aa-btn-action-secondary class="half-field"
                                             [btnText]="'ITSM.PROFILE.INFORMATIONS.UPDATE' | translate"
                                             [cta]="onUpdateProfile">
                    </aa-btn-action-secondary>
                </div>
            </fieldset>
            <!-- <span class="small-text-link"
              (click)="onAddContact()">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP4.CONTACT.ADD' | translate }}</span> -->
            <ng-container formArrayName="contacts"
                          *ngIf="stepForm.controls.contacts.controls.length > 0">
                <div *ngFor="let contact of stepForm.controls.contacts.controls; let i=index">
                    <fieldset [formGroupName]="i">
                        <legend>Contact {{i + 1}} - <span class="small-text-link"
                                  (click)="onRemoveContact(i)">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP4.CONTACT.REMOVE' | translate }}</span>
                        </legend>
                        <div class="input-row">
                            <aa-input-email2 class="full-field"
                                             name="email"
                                             required
                                             label="{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP4.EMAIL' | translate }}"
                                             formControlName="email">
                            </aa-input-email2>
                            <aa-input-text2 class="half-field"
                                            name="firstName"
                                            label="{{ 'ITSM.PROFILE.INFORMATIONS.FIRSTNAME' | translate }}"
                                            formControlName="firstName">
                            </aa-input-text2>
                            <aa-input-text2 class="half-field"
                                            name="lastName"
                                            label="{{ 'ITSM.PROFILE.INFORMATIONS.NAME' | translate }}"
                                            formControlName="lastName">
                            </aa-input-text2>
                        </div>
                    </fieldset>
                </div>
            </ng-container>
        </div>
    </div>
</form>
